<template>
  <div class="pt-4">
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div
        v-if="showDashboard===0"
        class="row"
      >
        <div
          v-if="vendorManagementAvailable"
          class="col-lg-6 mb-3"
        >
          <VendorManagementRequestCreationChart />
        </div>
        <div
          v-if="vendorManagementAvailable"
          class="col-lg-6 mb-3"
        >
          <VendorManagementRequestChart />
        </div>

        <div
          v-if="vendorManagementAvailable"
          class="col-lg-12 "
        >
          <VendorManagementPurchaseChart />
        </div>

        <div class="col-12 mb-3">
          <DashboardAnnouncements />
        </div>

        <div
          v-if="sessionType === 'company'"
          class="col-md-12"
        >
          <MyCabinetMenu
            :profile="profile"
            :vendor-managment-status="vendorManagementAvailable"
            :request-status-statistics="requestStatusStatistics"
          />
        </div>
        <div class="col-lg-8 ">
          <div v-if="sessionType === 'company'">
            <div v-if="dashboardResponse">
              <TruckDashboard
                v-if="profile === CompanyProfileType.TRUCK"
                :dashboard-response="dashboardResponse"
              />

              <LogisticDashboard
                v-else-if="profile === CompanyProfileType.LOGISTIC"
                :dashboard-response="dashboardResponse"
              />

              <NormalDashboard
                v-else
                :sectors="sectors"
                :profile="profile"
              />
            </div>
          </div>
          <div v-else>
            <div class="text-center">
              <router-link
                class="btn btn-primary"
                :to="{name: 'changeAccount' }"
              >
                {{ $t('dashboardVue.profilSein') }}
              </router-link>
            </div>
          </div>
        </div>
        <div
          v-if="company"
          class="col-lg-4"
        >
          <DashboardActiveCompanyCard
            :company="company"
            :position="position"
            :profile="profile"
            style="margin-top: 37px;"
          />
          <DashboardCompanyBoard />
          <DashboardCompanyUsers />
        </div>
      </div>
      <div
        v-else
        class="row"
      >
        <div class="col-sm-12 p-0">
          <div class="auth-innerright">
            <div class="authentication-box" />
            <div class="card mt-4 p-4">
              <div
                class="alert alert-primary text-center my-4"
                style="padding: 50px 20px;"
              >
                <feather
                  type="clock"
                  size="40"
                />
                <br>
                <span v-if="showDashboard===1">
                  {{
                    $t('dashboardVue.sizinBuIrktQoulmanzNIrktinizinAdminiTrfindnTsdiqln', {
                      adminName: company.adminName,
                      adminSurname: company.adminSurname
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  getAdvice, getCompanyUsers,
  getDashboard,
  getVendorManagementStatus,
  userAccounts,
  userMe
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";

import {CompanyProfileType} from "@/repositories/Enums";
import LogisticDashboard from "@/pages/scc/dashboard/LogisticDashboard.vue";
import TruckDashboard from "@/pages/scc/dashboard/TruckDashboard.vue";
import NormalDashboard from "@/components/dashboard/NormalDashboard.vue";
import MyCabinetMenu from "@/components/dashboard/MyCabinetMenu.vue";
import DashboardActiveCompanyCard from "@/components/dashboard/DashboardActiveCompanyCard.vue";
import DashboardCompanyBoard from "@/components/dashboard/DashboardCompanyBoard.vue";
import DashboardCompanyUsers from "@/components/dashboard/DashboardCompanyUsers.vue";
import DashboardAnnouncements from "@/components/dashboard/DashboardAnnouncements.vue";
import VendorManagementRequestChart from "@/pages/scc/vendorManagement/reports/VendorManagementRequestChart.vue";
import VendorManagementRequestCreationChart
  from "@/pages/scc/vendorManagement/reports/VendorManagementRequestCreationChart.vue";
import VendorManagementPurchaseChart from "@/pages/scc/vendorManagement/reports/VendorManagementPurchaseChart.vue";
import {store} from "@/store";


export default {
  components: {
    VendorManagementRequestChart, VendorManagementRequestCreationChart, VendorManagementPurchaseChart,
    DashboardAnnouncements,
    DashboardCompanyUsers,
    DashboardCompanyBoard,
    DashboardActiveCompanyCard,
    MyCabinetMenu,
    NormalDashboard,
    TruckDashboard, LogisticDashboard
  },
  data() {
    return {
      users:[],
      adminUser:null,
      mediaBase: mediaBase,
      profiles: [],
      showDashboard: 0,
      sectors: [],
      myRequestStatusStatistics: [],
      CompanyProfileType: CompanyProfileType,
      dashboardResponse: null,
      vendorManagementAvailable: false,
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
      sectorAdded: state => state.auth.sectorAdded,
      packageStatus: state => state.auth.userPackageStatus,

    }),

    companyList() {

      let idList = [];
      let list = [];

      this.profiles.forEach(p => {
        if (idList.indexOf(p.company.id) === -1) {
          idList.push(p.company.id);
          list.push(p.company);
        }
      })

      return list;

    },


    requestStatusStatistics() {

      let obj = {};

      this.myRequestStatusStatistics.forEach(s => {
        obj[s.keyword] = s.counter;
      });
      return obj;
    }

  },
  watch: {
    token(newValue) {
      userAccounts(newValue).then(data => {
        this.profiles = data;
      });
    },
    sessionType(newVal) {
      if (newVal !== 'company') {
        this.$router.push({name: 'changeAccount'});
      } else {
        this.getDashboard();
      }
    },
  },
  mounted() {

    this.userAccount();
    this.timer = setInterval(() => {
      this.userAccount();
      this.getDashboard();
      this.userMEE();
    }, 5000)
    this.getCompanyUsers();
    if (this.sessionType && this.sessionType !== 'company') {
      this.$router.push({name: 'changeAccount'});
    } else {
      this.getDashboard();
      getAdvice(0, this.token).then((advice) => {
        if (advice) {
          this.$swal({
            title: `${advice.title}`,
            html: `${advice.description}`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: this.$t("btnTvsylr"),
            cancelButtonText: this.$t("tmm"),
          }).then((res) => {
            if (res) {
              this.$router.replace({name: 'advices'});
            }
          })
        }
      });
    }
  },
  beforeDestroy() {
    // Clear the interval to prevent memory leaks when the component is destroyed
    if (this.newUserInterval) {
      clearInterval(this.newUserInterval);
    }
  },
  methods: {
    getCompanyUsers() {
      getCompanyUsers(this.token).then(data => {
        if (data.code === 200) {
          this.users = data.users;
          this.adminUser = data.adminUser;

          // Check for users with `new` status and show swal if found
          this.checkNewUsers();

          // Set interval to check every 5 minutes
          if (!this.newUserInterval) {
            this.newUserInterval = setInterval(() => {
              this.checkNewUsers();
            }, 7 * 60 * 1000); // 5 minutes in milliseconds
          }
        }
      });
    },
    checkNewUsers() {
      if (!this.company?.adminName?.length>0){
        return
      }

      if (this.company.adminName!==this.user.name){
        return;
      }
      const newUsers = this.users.filter(user => user.status === 'new' && user.user.id !== this.user.id);

      if (newUsers.length > 0) {
        this.$swal.fire({
          title: 'Yeni işçi!',
          text: `Şirkətinizə qoşulmaq istəyən yeni müraciətçi var`,
          icon: 'info',
          confirmButtonText: 'Müraciətə bax',
          showCancelButton: true,
          cancelButtonText: 'Sonra'
        }).then(
            (value) => {
              if (value.isConfirmed) this.$router.push("/dashboard/company/profile");
            }
        );
      }
    },
    userMEE() {
      userMe(this.token).then(({
                                 code,
                                 message,
                                 type,
                                 user,
                                 notificationCount,
                                 messageCount,
                                 company,
                                 profileType,
                                 position,
                                 package: userPackage,
                                 packageStatus,
                                 limits,
                                 sectorAdded,
                                 hasAdmin, isAdmin, companyUserStatus
                               }) => {
        if (code === 200) {
          store.dispatch('auth/setUser', user);
          store.dispatch('auth/setNotificationCount', notificationCount);
          store.dispatch('auth/setMessageCount', messageCount);
          store.dispatch('auth/setCompany', company);
          store.dispatch('auth/setProfile', profileType);
          store.dispatch('auth/setPosition', position);
          store.dispatch('auth/setSessionType', type);
          store.dispatch('auth/setUserPackage', userPackage);
          store.dispatch('auth/setUserPackageStatus', packageStatus);
          store.dispatch('auth/setPackageLimits', limits);
          store.dispatch('auth/setSectorAdded', !!sectorAdded);
          store.dispatch('auth/setHasAdmin', !!hasAdmin);
          store.dispatch('auth/setIsAdmin', !!isAdmin);
          store.dispatch('auth/setCompanyUserStatus', companyUserStatus);
        }
      })
    },
    userAccount() {

      userAccounts(this.token).then(data => {
        this.profiles = data;this.profiles = data;
        let ae = data.filter(profile => {
          return profile.company.id === this.company.id && profile.profileType === this.profile;
        });

        if (ae.length > 0 && this.company.adminName) {
          this.showDashboard = (ae[0].status === "verified") ? 0 : 1;
        }
        if (this.showDashboard === 0) {
          clearInterval(this.timer);
        }
      });
    },

    getDashboard() {

      if (this.sessionType === 'personal') {
        this.sectors = [];
      } else {
        getDashboard(this.token, this.$i18n.locale).then(d => {
          if (d.code === 200) {

            getVendorManagementStatus(this.token).then(({code}) => {
              this.vendorManagementAvailable = (code === 200);
            })

            this.dashboardResponse = d;
            this.sectors = d.sectors;
            this.myRequestStatusStatistics = d.myRequestStatusStatistics;

            if (d.notRatedWinners.length > 0) {

              if (!localStorage.getItem('notRatedWinnersTaskControl')
                  || localStorage.getItem('notRatedWinnersTaskControl') < new Date().getMilliseconds() - 60 * 60 * 1000) {
                this.$swal({
                  title: this.$t("generalModal.warningTitle"),
                  text: this.$t("sznDyrlndrlmmsZhmt", {length: d.notRatedWinners.length}),
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.$t("qrrVr"),
                  cancelButtonText: this.$t("inHourRemmbr")
                }).then((result) => {
                  if (result.value) {
                    this.$router.replace({name: 'purchases'});
                  } else {
                    localStorage.setItem('notRatedWinnersTaskControl', new Date().getMilliseconds());
                  }
                })
              }
            } else if (d.notRatedWinnings.length > 0) {
              if (!localStorage.getItem('notRatedWinningsTaskControl')
                  || localStorage.getItem('notRatedWinningsTaskControl') < new Date().getMilliseconds() - 60 * 60 * 1000) {
                this.$swal({
                  title: this.$t("generalModal.warningTitle"),
                  text: this.$t("sznStshinizVarQrrVerin", {length: d.notRatedWinnings.length}),
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.$t("qrrVr"),
                  cancelButtonText: this.$t("inHourRemmbr")
                }).then((result) => {
                  if (result.value) {
                    this.$router.replace({name: 'sales'});
                  } else {
                    localStorage.setItem('notRatedWinningsTaskControl', new Date().getMilliseconds());
                  }
                })
              }
            } else {
              d.myRequestStatusStatistics.forEach((s) => {
                if (s.keyword === 'EXPIRED' && s.counter > 0) {
                  if (!localStorage.getItem('expiredTaskControl')
                      || localStorage.getItem('expiredTaskControl') < new Date().getMilliseconds() - 60 * 60 * 1000) {
                    this.$swal({
                      title: this.$t("generalModal.warningTitle"),
                      text: this.$t("sznTmmlnmSrgnz", {counter: s.counter}),
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: this.$t("qrrVr"),
                      cancelButtonText: this.$t("inHourRemmbr")
                    }).then((result) => {
                      if (result.value) {
                        this.$router.replace({name: 'myRequests', query: {status: 'EXPIRED'}});
                      } else {
                        localStorage.setItem('expiredTaskControl', new Date().getMilliseconds());
                      }
                    })
                  }
                }
              })
            }
          }
          if (d.code !== 200) {
            window.location.reload();
          }
        })
      }
    },
  }
}
</script>
<style scoped>

.floating-action-button {
  display: block;
  position: fixed;
  right: 30px;
  bottom: 30px;
  background: white;

  border-radius: 100%;
  width: 60px;
  height: 60px;
  padding: 10px;
  box-shadow: 0 0 3px #0b2e13;
  z-index: 1100;
  cursor: pointer;
}

.cursor-enabled {
  cursor: pointer;
}

@keyframes blink {
  50% {
    opacity: 0.2;
  }
}

@-webkit-keyframes blink {
  50% {
    opacity: 0.2;
  }
}

</style>
